import type { StNavItem } from './types';

export const GROWTH_SETTINGS_META = {
  eyebrow: 'Settings',
  titleLead: 'Marketing',
  titleAccent: 'settings',
  description:
    'Manage connections, budgets, automation, and content preferences for your digital marketing suite.',
} as const;

/**
 * Grouped sub-nav for the settings shell. Items are bucketed by `group`
 * (Integrations / Campaigns / Practice / Automation / Content) in nav order.
 */
export const GROWTH_SETTINGS_NAV: readonly StNavItem[] = [
  { id: 'connections', label: 'Connections', group: 'Integrations', icon: 'link' },
  { id: 'budget-guardrails', label: 'Budget & Guardrails', group: 'Campaigns', icon: 'shield' },
  { id: 'practice-profile', label: 'Practice Profile', group: 'Practice', icon: 'team' },
  { id: 'target-area', label: 'Target Area', group: 'Practice', icon: 'pin' },
  { id: 'autopilot-rules', label: 'Autopilot Rules', group: 'Automation', icon: 'bolt' },
  { id: 'notifications', label: 'Notifications', group: 'Automation', icon: 'bell' },
  { id: 'content-preferences', label: 'Content Preferences', group: 'Content', icon: 'image' },
] as const;

export const GROWTH_SETTINGS_GROUP_ORDER: readonly string[] = [
  'Integrations',
  'Campaigns',
  'Practice',
  'Automation',
  'Content',
] as const;
